function parallaxUpdate(evt, obj){
    var vw = jQuery(window).width();
    var vh = jQuery(window).height();
    var st = jQuery(window).scrollTop();
    var sl = jQuery(window).scrollLeft();
    var pos = jQuery(obj).offset();
    var ot = pos.top;
    var ol = pos.left;
    var ow = jQuery(obj).innerWidth();
    var oh = jQuery(obj).innerHeight();

    // Check if element is in viewport
    if(st + vh < ot) return;
    if(st > ot + oh) return;

    var iw = parseInt(jQuery(obj).attr('data-parallax-img-width'));
    var ih = parseInt(jQuery(obj).attr('data-parallax-img-height'));
    var parallax_ratio = parseFloat(jQuery(obj).attr('data-parallax-ratio'));
    parallax_ratio = (isNaN(parallax_ratio)) ? 1 : parallax_ratio;
    var expand_ratio = parseFloat(jQuery(obj).attr('data-parallax-expand'));
    expand_ratio = (isNaN(expand_ratio)) ? 1 : expand_ratio;

    // Calculate image size
    var img_wh = ((iw / ih) < (ow / oh));
    var img_ratio = (img_wh) ? (iw / ow) : (ih / oh);
    var fw = iw / img_ratio * expand_ratio;
    var fh = ih / img_ratio * expand_ratio;
    var fsize = fw + 'px ' + fh + 'px';

    // Calculate scroll delta
    var t = Math.abs((ot - vh - st));
    var m = vh + oh;
    var d = t / m;

    // Vertical parallax only - centralizing image horizontally
    var px = ((fw - ow) / 2) * -1;
    
    // Calculate image position
    var py = 0;
    py = ((fh - oh) * d) * -1;
    var fpos = px + 'px ' + (py+120) + 'px';

    // Settings properties
    jQuery(obj).css({
        'background-size': fsize,
        'background-position': fpos
    });
}
function parallaxUpdateAll(evt, cls){
    jQuery(cls).each(function(idx, obj){
        parallaxUpdate(null, obj);
    });
}
function parallaxInit(cls){
    jQuery(cls).each(function(idx, obj){
        var url = jQuery(obj).attr('data-parallax-img');
        jQuery(obj).css({
            'background-image': 'url(' + url + ')',
            'background-repeat': 'no-repeat'
        });
        parallaxUpdate(null, obj);
    });
    jQuery(cls).on('resize', parallaxUpdate);
    jQuery(window).on('scroll', function(evt){ parallaxUpdateAll(evt, cls); });
    jQuery(window).on('resize', function(evt){ parallaxUpdateAll(evt, cls); });
}
